import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CorePrompt',
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: function _default() {
        return '';
      }
    },
    title: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '500px'
    },
    color: {
      type: String,
      default: ''
    },
    buttons: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    checkBoxLable: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isOpen: this.open,
      itemIsSelected: false
    };
  },
  watch: {
    open: function open() {
      this.isOpen = this.open;
    }
  },
  methods: {
    handleButtonClick: function handleButtonClick(btnIdx) {
      this.$emit('close');
      this.$emit(this.buttons[btnIdx].emit, this.value);
    }
  }
};